export const blockOdd = () => {
  const tipsodd = document.querySelectorAll('.gtm-tips')
  if (tipsodd) {
    tipsodd.forEach((odd) => {
      if (odd.childElementCount === 1) {
        odd.classList.add('one-odd')
      }
    })
  }
}
